import { render, staticRenderFns } from "./WalletHistories.vue?vue&type=template&id=6f586bbd"
import script from "./WalletHistories.vue?vue&type=script&lang=ts"
export * from "./WalletHistories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports